import { BetContext } from "@/context/BetContext";
import FloatDialog from "./_floatDialog";
import { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import Icon from "@/components/etc/icon";
import { AuthContext } from "@/context/authContext";
import { del_comma, with_comma } from "@/util/comma";
import customAlert from "@/util/customAlert";
import api from "@/util/api";
import getQueryString from "@/util/queryString";
import moment from "moment";
import { betDetailTypes, ticketResult } from "@/type/sports";
import Pagenation from "@/components/common/pagenation";
import Detail from "@/components/bet/detail";
import { useTranslations } from "next-intl";

export default function FloatBetDetail() {
    const { user, loading } = useContext(AuthContext)
    const { betDetailShow, setBetslipShow, setBetDetailShow, fetchBetDetails, detailList, totalCount, deleteAllBetTickets } = useContext(BetContext)

    const [page, setPage] = useState<number>(1)
    const perPage = 6

    const t = useTranslations("Text")

    useEffect(() => {
        fetchBetDetails(page, perPage);
    }, [page, loading])

    return (
        <FloatDialog
            show={betDetailShow}
            setShow={setBetDetailShow}
            className="bet-detail"
        >
            <FloatDialog.Head>
                <div className="page-tabs">
                    <ul className="box-page col4">
                        <li onClick={e => {
                            setBetDetailShow(false)
                            setBetslipShow(true)
                        }}>{t("베팅 카트")}</li>
                        <li className="active">{t("베팅 내역")}</li>
                    </ul>
                </div>
            </FloatDialog.Head>
            <FloatDialog.Body>
                <div className="page-tabs">
                    <ul className="button-page col5">
                        <li>{t("전체")}</li>
                        <li>{t("당첨")}</li>
                        <li>{t("낙첨")}</li>
                        <li>{t("새로고침")}</li>
                        <li className="clear" onClick={e=> deleteAllBetTickets()}>{t("전체삭제")}</li>
                    </ul>
                </div>
                <div className="bet-detail-container">
                    {
                        detailList.map((li, index) => {
                            const folders = li.folders
                            return (
                                <div className="bet-details" key={index}>
                                    <ul className="folders-list">
                                        {
                                            folders.map((fl, index) => {
                                                return (
                                                    <Detail key={index}>
                                                        <Detail.Info league_name={fl.competition_name}
                                                            match_datetime={fl.match_datetime}
                                                            home={fl.home_team}
                                                            away={fl.away_team} />
                                                        <Detail.Selections folder={fl} />
                                                    </Detail>
                                                )
                                            })
                                        }
                                    </ul>
                                    <footer className="folder-info">
                                        <div className="info-raw">
                                            <p>
                                                <span>{t("베팅시간")}:</span>
                                                <span className="bettime">{moment(li.created_dt).format('YYYY-MM-DD HH:mm:ss')}</span>
                                            </p>
                                            <p>
                                                <span>{t("베팅포인트")}:</span>
                                                <span>{with_comma(li.stake)}P</span>
                                            </p>
                                        </div>
                                        <div className="info-raw">
                                            <p>
                                                <span>{t("배당률")}:</span>
                                                <span>{li.total_odds}</span>
                                            </p>
                                            <p>
                                                <span>{t("예상적중포인트")}</span>
                                                <span>{with_comma(li.expected_price)} P</span>
                                            </p>
                                        </div>
                                        <div className="info-raw">
                                            <p>
                                                <span>{t("적중 포인트")}:</span>
                                                <span>{with_comma(li.paid_price)} P</span>
                                            </p>
                                            <div className="ticket-btns">
                                                {/* <button className="sharing">공유하기</button> */}
                                                <button className={`list-result ${li.status}`}>{ticketResult[li.status]}</button>
                                            </div>
                                        </div>
                                    </footer>
                                </div>
                            )
                        })
                    }
                </div>

                <Pagenation totalCount={totalCount} perPage={perPage} setPage={setPage} />
            </FloatDialog.Body>
        </FloatDialog>
    )
}